import { render } from "./EditGhostModal.vue?vue&type=template&id=af22e004"
import script from "./EditGhostModal.vue?vue&type=script&lang=js"
export * from "./EditGhostModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__